import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import * as React from 'react';
import { Text } from '@marvelapp/ballpark-components';
import { Box } from '@marvelapp/ui';
export default observer(function Subtitles({ children, isVideo, }) {
    return (_jsx(Box, { bg: isVideo ? 'blackA9' : 'whiteA9', borderRadius: "s", boxShadow: isVideo ? undefined : 'borders.black', paddingX: "xxs", paddingY: "xs", width: "100%", children: _jsx(Text, { color: isVideo ? 'whiteA12' : 'blackA12', fontWeight: "medium", lineHeight: "heading", size: "xs", textAlign: "center", children: children }) }));
});
